export const AccountSuspensionAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    self.checkAccountSuspension = cacheService.cache((brandId) => {
        const defer = $q.defer();

        _protected.request(`brands/${brandId}/account_suspension/check`, 'GET')
            .then((res) => {
                if (res?.data?.data && res.status === 200) {
                    defer.resolve(res.data.data.is_suspended);
                } else {
                    defer.reject(res);
                }
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    })[0];
});